<nav @smoothShow class="sidebar__container" *ngIf="!( isCollapsed$ | async )">

	<div class="sidebar__header">
		<span (click)="onSidebarClosed()" class="sidebar__close" gtagEvent="cerrar" gtagCategory="menú-lateral"></span>
		<div>Menú</div>
	</div>

	<div #content class="sidebar__content" (click)="onAccessSelected()">
		<access></access>
	</div>

</nav>
